import React from "react";

// CTA App Store — temporairement non cliquable : « Bientôt sur l'App Store »
const AppStoreBadge = ({ className = "", height = 52, url = "https://apps.apple.com/ca/app/velis-productivity/id6792467812?l=fr-CA" }) => {
  return (
   <a
  href={url}
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Télécharger VÉLIS dans l’App Store"
  className={`inline-flex flex-col items-center gap-2 cursor-pointer select-none ${className}`}
>

      <img
        src="/images/app-store-badge-fr.svg"
        alt="App Store"
        style={{ height: `${height}px`, width: "auto" }}
      />
    </a>
  );
};

export default AppStoreBadge;
